export default __webpack_public_path__ + "static/media/The_Wales_Brochure.7deddb96.pdf";